import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";
import moment from "moment";

const TransactionView = () => {
  const { id } = useParams();
  const [transaction, setTransaction] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Http.get(`/accounts/fund-transfers/${id}`)
      .then((res) => {
        setTransaction(res.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Transaction Details</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Transaction Information</h6>
            
            {loading ? (
              <div className="text-center">
                <ProgressSpinner />
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <tbody>
                    <tr>
                      <th width="200">Date</th>
                      <td>{transaction.date ? moment(transaction.date).format("DD/MM/YYYY") : "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Reference</th>
                      <td>{transaction.reference || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Account</th>
                      <td>{transaction.account?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Type</th>
                      <td>
                        <span className={`badge ${transaction.type === 'income' ? 'bg-success' : 'bg-danger'}`}>
                          {transaction.type === 'income' ? 'Income' : 'Expense'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th>Amount</th>
                      <td>{transaction.amount ? `${transaction.amount.toFixed(2)}` : "0.00"}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>{transaction.description || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Created By</th>
                      <td>{transaction.created_by?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Created At</th>
                      <td>
                        {transaction.created_at
                          ? moment(transaction.created_at).format("DD/MM/YYYY hh:mm A")
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>
                        {transaction.updated_at
                          ? moment(transaction.updated_at).format("DD/MM/YYYY hh:mm A")
                          : "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionView;